/* eslint-disable max-len */
import { number, string } from 'prop-types';
import React from 'react';

const IconCheckboxIndeterminate = ({
  size = 16,
  fill = '#4F4F4F',
  stroke = '#94A2B7',
}) => {
  return (
    <svg className="icon-checkbox-indeterminate" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        rx="1.5"
        fill="#ffffff"
        stroke={stroke}
      />
      <rect x="2" y="7" width="12" height="2" rx="0.5" fill={fill} />
    </svg>
  );
};
IconCheckboxIndeterminate.propTypes = {
  size: number,
  fill: string,
  stroke: string,
};

export default IconCheckboxIndeterminate;
